import { capitalizeAllIfLower, formatAddressToString, formatDate, getPlaceAddress } from '@btime/helpers'
import { useSessionPermission } from '@btime/react-session'
import { compose, prop, propOr } from 'ramda'
import React from 'react'

import { incrementCheckout, shouldIncrementCheckout } from '../../../../utils/helpers/serviceOrder'
import LabelValue from '../../../../components/pdf/LabelValue'
import StatusReasonLabelValue from './StatusReasonLabelValue'
import CustomFields from './CustomFields'
import Documents from './Documents'

const Overview = ({ serviceOrder }) => {
  const description = prop('description', serviceOrder)
  const checklistName = !!serviceOrder.name && capitalizeAllIfLower(serviceOrder.checklist?.name)
  const place = propOr({}, 'place', serviceOrder)
  const serviceOrderAddress = compose(formatAddressToString, propOr({}, 'address'))(serviceOrder)

  const placeAddress = compose(formatAddressToString, getPlaceAddress)(place)
  const finalAddress = serviceOrderAddress || placeAddress
  const checkInTime = compose(formatDate('DD/MM/YYYY HH:mm'), propOr('', 'startDate'))(serviceOrder)
  let checkOutTime = propOr('', 'endDate', serviceOrder)
  checkOutTime = shouldIncrementCheckout(serviceOrder)
    ? compose(formatDate('DD/MM/YYYY HH:mm'), incrementCheckout)(checkOutTime)
    : formatDate('DD/MM/YYYY HH:mm', checkOutTime)
  const hideCheckinAndCheckout = useSessionPermission('hideCheckinAndCheckout')
  return (
    <div>
      {checklistName && <LabelValue label="Questionário" value={checklistName} />}
      {serviceOrder.place && <LabelValue label={'Destino'} value={place.resume + ' - ' + place.name} />}
      {serviceOrder.asset && <LabelValue label={'Ativo'} value={serviceOrder.asset.name} />}
      {description && <LabelValue label="Observações" value={description} />}
      {!!finalAddress && <LabelValue label="Endereço" value={finalAddress} />}

      {!hideCheckinAndCheckout && <LabelValue label="Check In" value={checkInTime} />}
      {!hideCheckinAndCheckout && <LabelValue label="Check Out" value={checkOutTime} />}

      <StatusReasonLabelValue serviceOrder={serviceOrder} />
      <LabelValue label="Atividade" value={serviceOrder.yearlyId} />
      <CustomFields serviceOrder={serviceOrder} />
      <Documents serviceOrder={serviceOrder} />
    </div>
  )
}

export default Overview
